
import Coupon from './coupon.vue'

export default {
	Coupon,
}



// WEBPACK FOOTER //
// ./src/views/coupon/index.js